import { createApi } from "@reduxjs/toolkit/query/react";

import {
  baseQuery,
  GET_DOWNLOAD_SIGNED_URL,
  GET_UPLOAD_SIGNED_URL,
  GET_UPLOAD_SIGNED_URL_FOR_TRADE_DATA,
} from "@/graphql";

interface SignedUploadUrlResponse {
  generateUploadSignedUrl: { signedUrl: string; key: string };
  generateSignedUrlForTradeData: { signedUrl: string; key: string };
}

interface SignedAccessUrlResponse {
  generateAccessSignedUrl: { signedUrl: string; key: string };
}

export const signedUrlApi = createApi({
  reducerPath: "api/signedUrl",
  baseQuery,
  endpoints: (builder) => ({
    getUploadSignedUrl: builder.query<
      SignedUploadUrlResponse["generateUploadSignedUrl"],
      { fileName: string; contentType: string }
    >({
      query: (variables) => ({
        document: GET_UPLOAD_SIGNED_URL,
        variables: { ...variables },
      }),
      transformResponse: (response: SignedUploadUrlResponse) =>
        response.generateUploadSignedUrl,
    }),
    getUploadSignedUrlForTradeData: builder.query<
      SignedUploadUrlResponse["generateSignedUrlForTradeData"],
      {
        fileName: string;
        contentType: string;
        index?: string;
        clientId?: string;
        tenantId?: string;
        timeStamp?: string;
      }
    >({
      query: (variables) => ({
        document: GET_UPLOAD_SIGNED_URL_FOR_TRADE_DATA,
        variables: { ...variables },
      }),
      transformResponse: (response: SignedUploadUrlResponse) =>
        response.generateSignedUrlForTradeData,
    }),
    getAccessSignedUrl: builder.query<
      SignedAccessUrlResponse["generateAccessSignedUrl"],
      { fileName: string }
    >({
      query: (variables) => ({
        document: GET_DOWNLOAD_SIGNED_URL,
        variables: { ...variables },
      }),
      transformResponse: (response: SignedAccessUrlResponse) =>
        response.generateAccessSignedUrl,
    }),
  }),
});

export const {
  useLazyGetUploadSignedUrlQuery,
  useLazyGetAccessSignedUrlQuery,
  useLazyGetUploadSignedUrlForTradeDataQuery,
} = signedUrlApi;
